import React, { Component } from "react";
import "./index.css";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

/* Actions */
import { setAlert } from "../../../../redux/actions/misc";
import { setCVProfile, setCVApplication } from "../../../../redux/actions/admin";

/* API requests */
import { getApplication, rejectApplication, restoreApplication } from "../../../../api-requests/application";

/* Components */
import OnlineCV from "../../../DashboardCandidate/components/CV/components/OnlineCV";
import DashboardSectionBase from "../../../../components/DashboardSectionBase";
import { updateCandidate } from "../../../../api-requests/candidate";
import { handleYachtName } from "../../../../helpers/job";

class Application extends Component {

    constructor(props) {
        super(props);
        this.state = { user: null, application: {}, isUpdating: false };
    }

    flashAlert = (message) => {
        this.props.setAlert(message, "success", true);
        setTimeout(() => this.props.setAlert(message, "success", false), 2700);
    }

    handleReject = () => {
        const id = this.state.application?._id;
        if (!id || this.state.isUpdating) return;
        return this.setState({ isUpdating: true }, () => {
            return rejectApplication(id)
                .then(result => {
                    if (!result?.success) return this.setState({ isUpdating: false });
                    return getApplication(id)
                        .then(refreshed => {
                            this.props.setCVApplication(refreshed.application);
                            this.setState({ application: refreshed.application, isUpdating: false });
                            this.flashAlert("Candidate rejected");
                        });
                });
        });
    }

    handleRestore = () => {
        const id = this.state.application?._id;
        if (!id || this.state.isUpdating) return;
        return this.setState({ isUpdating: true }, () => {
            return restoreApplication(id)
                .then(result => {
                    if (!result?.success) return this.setState({ isUpdating: false });
                    return getApplication(id)
                        .then(refreshed => {
                            this.props.setCVApplication(refreshed.application);
                            this.setState({ application: refreshed.application, isUpdating: false });
                            this.flashAlert("Candidate restored");
                        });
                });
        });
    }

    componentDidMount() {
        const dash = document.getElementById("Dashboard");
        if (dash && dash.scrollTo) dash.scrollTo(0, 0);

        if (this.props.match.params.applicationId) {
            return getApplication(this.props.match.params.applicationId)
                .then(result => {
                    this.props.setCVProfile(result.user);
                    this.props.setCVApplication(result.application);
                    return this.setState({ application: result.application, user: result.user });
                });
        }
    }

    saveCandidateNotes = (_id, value) => {
        return updateCandidate(_id, [{ propName: "notes", value: value }])
            .then(_ => {
                this.props.setAlert("Candidate notes updated!", "success", true);
                return setTimeout(() => this.props.setAlert("Candidate notes updated!", "success", false), 2700);
            });
    }

    render() {

        const application = this.state.application;
        const yacht = application?.job?.yacht;
        const position = application?.job?.position?.name;
        const candidate = this.state.user;
        const fullName = candidate ? `${candidate.firstName || ""} ${candidate.lastName || ""}`.trim() : "";
        const yachtTitle = yacht ? `${handleYachtName(yacht)}${position ? " — " + position : ""}` : "";

        const yachtId = this.props.match.params.yachtId;
        const jobId = this.props.match.params.jobId;
        const isYachtPath = this.props.match.path.includes("/yachts");
        const baseTab = application?.rejected ? "/rejected" : "";
        const backTo = yachtId && jobId
            ? (isYachtPath
                ? `/yachts/listings/${yachtId}/applications/${jobId}${baseTab}`
                : `/listings/applications/${yachtId}/job/${jobId}${baseTab}`)
            : null;

        return(
            <div className="admin-page">
                <header className="admin-page-header">
                    <div className="admin-page-header-titles">
                        {backTo &&
                            <Link to={backTo} className="admin-page-back">
                                <span aria-hidden="true">&larr;</span>
                                <span>Back to applications</span>
                            </Link>
                        }
                        <h1 className="admin-page-title">{fullName || "Application"}</h1>
                        {yachtTitle && <p className="admin-page-subtitle">Applied to {yachtTitle}</p>}
                    </div>
                    {application?._id && (
                        application.rejected ? (
                            <button
                                type="button"
                                className="admin-page-action admin-page-action--ghost"
                                disabled={this.state.isUpdating}
                                onClick={this.handleRestore}
                            >
                                Restore candidate
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="admin-page-action admin-page-action--ghost"
                                disabled={this.state.isUpdating}
                                onClick={this.handleReject}
                            >
                                Reject candidate
                            </button>
                        )
                    )}
                </header>

                <div className="admin-cv-container">
                    <OnlineCV user={candidate} admin={true} application={true} />
                </div>

                <DashboardSectionBase title={"Candidate notes"} description={"Anything relevant about this candidate. Visible only to admins."}>
                    <textarea
                        className="admin-notes-textarea"
                        placeholder={"Add a note..."}
                        value={candidate?.profile?.notes || ""}
                        onChange={(e) => this.setState({ user: { ...this.state.user, profile: { ...this.state.user.profile, notes: e.target.value } } })}
                    />
                    <div className="admin-notes-actions">
                        <button
                            type="button"
                            className="admin-page-action admin-page-action--primary"
                            onClick={() => candidate?.profile && this.saveCandidateNotes(candidate.profile._id, candidate.profile.notes)}
                        >
                            Save notes
                        </button>
                    </div>
                </DashboardSectionBase>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({ setAlert, setCVProfile, setCVApplication }, dispatch)
});

export default connect(null, mapDispatchToProps)(Application);
